/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Catalog_Endpoints_MultiInputs */

const en_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each endpoint is priced on its cheapest serving provider. Open one to compare them all.`)
};

const zh_hans1_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个接口按当前服务中最便宜的服务商定价。打开一个接口即可比较所有服务商。`)
};

const pt_br2_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada endpoint tem o preço do provedor mais barato em operação. Abra um para comparar todos.`)
};

const es_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada endpoint tiene el precio de su proveedor activo más barato. Abre uno para compararlos todos.`)
};

const fr_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque endpoint est affiché au prix de son fournisseur le moins cher. Ouvrez-en un pour les comparer tous.`)
};

const de_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Endpoint wird nach seinem günstigsten liefernden Anbieter bepreist. Öffne einen, um alle zu vergleichen.`)
};

const ru_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена каждого эндпоинта указана по самому дешёвому из обслуживающих его поставщиков. Откройте эндпоинт, чтобы сравнить всех.`)
};

const it_app_catalog_endpoints_multi = /** @type {(inputs: App_Catalog_Endpoints_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni endpoint ha il prezzo del suo provider più economico che lo serve. Aprine uno per confrontarli tutti.`)
};

/**
* | output |
* | --- |
* | "Each endpoint is priced on its cheapest serving provider. Open one to compare them all." |
*
* @param {App_Catalog_Endpoints_MultiInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_catalog_endpoints_multi = /** @type {((inputs?: App_Catalog_Endpoints_MultiInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Catalog_Endpoints_MultiInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_catalog_endpoints_multi(inputs)
	if (locale === "pt-BR") return pt_br2_app_catalog_endpoints_multi(inputs)
	if (locale === "es") return es_app_catalog_endpoints_multi(inputs)
	if (locale === "fr") return fr_app_catalog_endpoints_multi(inputs)
	if (locale === "de") return de_app_catalog_endpoints_multi(inputs)
	if (locale === "ru") return ru_app_catalog_endpoints_multi(inputs)
	if (locale === "it") return it_app_catalog_endpoints_multi(inputs)
	return en_app_catalog_endpoints_multi(inputs)
});